import { CLIENT_CANCELLATION_REASONS, OPS_CANCELLATION_REASONS } from "@estaly/ui";

export default {
  namespaced: true,
  state: {},
  getters: {
    clientReasons: () => CLIENT_CANCELLATION_REASONS,
    opsReasons: () => OPS_CANCELLATION_REASONS,
  },
  mutations: {},
  actions: {},
};
